import { createContext, useContext } from 'react';

type MonetizationLightModeContextValue = {
  forceLightMode: boolean;
};

const MonetizationLightModeContext = createContext<MonetizationLightModeContextValue>({
  forceLightMode: false,
});

export const useMonetizationLightMode = () => useContext(MonetizationLightModeContext);

export default MonetizationLightModeContext;
